module.exports = __webpack_public_path__ + "img/108.700e5a82.jpg";